import { AxiosError } from 'axios';
import { Reducer } from 'redux';

import { initialState, RequestType, STATUS } from './constants';
import * as helpers from './helpers';
import { ApiRequestsReducerState as State } from './types';

export const apiRequestsReducer: Reducer<State> = (state = initialState, action): State => {
  const { statuses, errors } = state;

  // action.type example: user|updateProfile:start
  const [reqName, requestStatus] = action.type.split(':');
  const requestName = reqName.replace(`${RequestType.ADVANCED}.`, '');

  switch (requestStatus) {
    case STATUS.START:
      return {
        ...state,
        statuses: helpers.markAsInProgress(statuses, requestName),
        errors: helpers.removeErrors(errors, requestName),
      };

    case STATUS.STOP:
      return {
        ...state,
        statuses: helpers.markAsCompleted(statuses, requestName),
      };

    case STATUS.FAIL:
      return {
        ...state,
        statuses: helpers.markAsCompleted(statuses, requestName),
        errors: helpers.storeErrors(errors, requestName, action.error as AxiosError),
      };

    case STATUS.SUCCESS:
      return {
        ...state,
        statuses: helpers.markAsCompleted(statuses, requestName),
        errors: helpers.removeErrors(errors, requestName),
      };

    case STATUS.CLEAN_UP:
      return {
        ...state,
        errors: helpers.removeErrors(errors, requestName),
      };

    default:
      return state;
  }
};
